package one.healthium.med.di

import org.koin.dsl.module

internal actual fun composeAppPlatformModule() = module {
}